export const VALID_IMAGE_FILE_TYPE = ["image/jpeg", "image/png"];
export const VALID_IMAGE_INCLUDE_GIF_FILE_TYPE = ["image/gif", "image/jpeg", "image/png"];
export const VALID_DOC_FILE_TYPE = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
];



// WEBPACK FOOTER //
// ./src/constants/file-type.js